const TheContainer = () => import('@/containers/TheContainer')
const ProjectNotificationCompanySettings = () => import('@/setting/ProjectNotificationCompanySettings')

/** 初回F5・直リンクでも解決できる全体通知設定ルート。 */
export default function registerProjectNotificationRoutes (router) {
  router.addRoutes([
    {
      path: '/setting/project-notifications',
      component: TheContainer,
      children: [
        {
          path: '',
          name: '全体通知設定',
          component: ProjectNotificationCompanySettings,
          meta: { requiresAuth: true, feature: 'PROJECT', permission: 'PROJECT_MANAGE' }
        }
      ]
    }
  ])
}
